import React from "react";
import Links from "./Links";
import { useNavigate } from 'react-router-dom';
import { Nav } from 'react-bootstrap';
import bknr from '../components/assets/BKFR_1.2.1.jpg';
import IGSVG from './assets/instagram.svg';

function Footer({ currentPage, handlePageChange }) {
    const navigate = useNavigate();
  return (
<footer
  className="footer text-center"
  style={{
    width: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    padding: "12px 24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position: "relative",
  }}
>
  {/* Left: Instagram heading */}
<div
  style={{
    flex: "1",
    display: "flex",
    flexDirection: "column", // stack vertically
    alignItems: "flex-start",     // CENTER the children
    gap: "4px",               // space between heading and icon
  }}
>
  

  <Nav>
    <Nav.Link 
      href="https://www.instagram.com/brassknucklefilms/" 
      target="_blank" 
      rel="noopener noreferrer"
      className="custom-nav-link"
      style={{ padding: 0, textAlign: 'left', marginLeft: "clamp(8px, 2vw, 30px)" }}
    >
      <h2 className='footer-heading2 hover-brighten'
      >
       Follow us on Instagram
      </h2>
    </Nav.Link>
    </Nav>
</div>



  {/* Center: stacked headings */}
  <div style={{ flex: "1", display: "flex", flexDirection: "column", alignItems: "center", gap: "6px" }}>
     <Nav>
      <Nav.Link 
       onClick={() => {
              handlePageChange('Home');
              navigate('/');
            }}
            className={currentPage === 'Home' ? 'nav-link active' : 'nav-link'}
      >
        <img
          src={bknr}
          alt="Brass Knuckle Films logo"
          style={{ maxWidth: "15vmin", height: "auto" }}
        />
      </Nav.Link>
    </Nav>

    <Nav>
      <Nav.Link href="/Privacy" className="custom-nav-link" style={{ padding: 0 }}>
        <h2 className='footer-heading2 hover-brighten'
        style={{ margin: 0 }}>Privacy & Terms of Service</h2>
      </Nav.Link>
    </Nav>
  </div>

  {/* Right: Logo */}
  <div style={{ flex: "1", display: "flex", justifyContent: "flex-end" }}>
  <Nav>
    <Nav.Link 
             onClick={() => {
              handlePageChange('BKFMerchShop');
              navigate('/BKFMerchShop');
            }}
            className={currentPage === 'BKFMerchShop' ? 'nav-link active' : 'nav-link'}
      className="custom-nav-link"
      style={{ padding: 0, marginRight: "clamp(8px, 2vw, 30px)" }}
    >
      <h2 className='footer-heading2 hover-brighten'
      >
       Shop BKF Gear
      </h2>
    </Nav.Link>
    </Nav>
  </div>
</footer>



  );
}

export default Footer;
